import { layers, namedFlavor } from '@protomaps/basemaps'
import maplibregl, { StyleSpecification } from 'maplibre-gl'
import { Protocol } from 'pmtiles'

export const BASEMAP_ASSET_REVISION =
  '028c18f713baecad011301ff7a69acc39bcc2ae7'
export const MAP_SOURCE_NAME = 'protomaps'

const protocol = new Protocol()
let protocolRegistered = false

export function ensurePmtilesProtocol(): void {
  if (protocolRegistered) {
    return
  }

  maplibregl.addProtocol('pmtiles', protocol.tile)
  protocolRegistered = true
}

export function collapseMapAttribution(container: HTMLElement): void {
  const attribution = container.querySelector<HTMLElement>(
    '.maplibregl-ctrl-attrib'
  )

  if (!attribution?.classList.contains('maplibregl-compact')) {
    return
  }

  attribution.classList.remove('maplibregl-compact-show')
  attribution.setAttribute('open', '')
}

export function createPmtilesMapStyle(
  mapTilesBaseUrl: string,
  archiveUrl: string
): StyleSpecification {
  const baseUrl = mapTilesBaseUrl.replace(/\/+$/, '')

  return {
    version: 8,
    glyphs: `${baseUrl}/assets/${BASEMAP_ASSET_REVISION}/fonts/{fontstack}/{range}.pbf`,
    sprite: `${baseUrl}/assets/${BASEMAP_ASSET_REVISION}/sprites/v4/light`,
    sources: {
      [MAP_SOURCE_NAME]: {
        type: 'vector',
        url: `pmtiles://${archiveUrl}`,
        attribution:
          '<a href="https://protomaps.com">Protomaps</a> © <a href="https://www.openstreetmap.org/copyright">OpenStreetMap contributors</a>',
      },
    },
    layers: layers(MAP_SOURCE_NAME, namedFlavor('light'), {
      lang: 'en',
    }),
  }
}
